// extracted by mini-css-extract-plugin
export default {"trustedRetailerBanner":"G0-z","trustedRetailerTooltipWrapper":"H0-z"};